<template>
  <div v-if="active"
       class="modal is-active">
    <div class="modal-background"></div>
    <aside class="modal-card"
           qa="auth-modal"
           role="dialog"
           aria-modal="active"
           aria-labelledby="auth-modal"
           tabindex="-1">
      <!-- Modal Trapping Section -->
      <div aria-hidden="true"
           @focus="selectFirstElement()"
           tabindex="0" />
      <!-- Modal Trapping Ends -->
      <button aria-label="To close modal"
              class="close gtm-login-close cursor-pointer"
              ref="first_element"
              @click="close(false)">
        <i class="fal fa-times" />
      </button>
      <section class="section">
        <div>
          <div>
            <span class="title welcome-modal" qa="signup-modal-title">{{ $t("signup-modal.cwsf.title") }}</span>
          </div>
          <div class="container">
            <div class="make-login has-account-message">
              <div class="cwsf-parent-container">
                <yscStepOne :userRole="userRole" v-on:childToParent="onChildClick" />
              </div>
            </div>
          </div>
          <div class="next-button-container">
            <button class="button is-primary is-full-width continue-button"
                    @click="clickNext"
                    @keydown.tab.exact=null
                    qa="signup-continue-btn">
              {{ $t("signupSurvey.continueButton")}}
            </button>
          </div>
        </div>
      </section>
      <!-- Modal Trapping Section -->
      <div aria-hidden="true"
           @focus="selectFirstElement()"
           tabindex="0" />
      <!-- Modal Tappring Ends -->
    </aside>
  </div>
</template>

<script>
import link from '@/mixins/link'
import signup from '@/mixins/signup'
import i18n from '@/i18n'
import Checkbox from '@/components/Controls/Checkbox'
import componentState from '@/mixins/component-state'
import gaTrackingMixin from '@/mixins/ga-tracking'
import setYear from '@/mixins/set-year'
import userTypes from '@/mixins/user-types'
import YscStepOne from '@/components/Modals/ysc/YscStepOne'
import localStorage from 'store'

export default {
  components: {
    Checkbox,
    i18n,
    YscStepOne
  },
  mixins: [componentState, link, signup, gaTrackingMixin, userTypes, setYear],
  data: function () {
    return {
      userRole: {
        cwsfUser: false,
        cwsfViewer: false
      }
    }
  },
  computed: {
    active: function () {
      return this.$store.getters.modalIsVisible('yscPreRegistrationModal')
    },
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    usernamePlaceholder: function () {
      return i18n.t('login.chooseUsername')
    },
    modalData: function () {
      return this.$store.getters.modalData('yscPreRegistrationModal') || {}
    },
    title: function () {
      return i18n.t('login.signUp')
    }
  },
  mounted: function () {

  },
  methods: {
    selectFirstElement: function () {
      this.$refs.first_element.focus()
    },
    showModal: function () {
      this.active = true
      this.show()
      this.checkIfPersonalize()
    },
    close: function () {
      if (this.modalData.onClose) {
        this.modalData.onClose(false)
      }
      this.$store.dispatch('hideYscPreRegistrationModal')
    },
    clickNext: function () {
      if (this.userRole) {
        if (this.userRole.cwsfUser) {
          if (this.modalData.onSuccess) {
            this.modalData.onSuccess()
          }
        } else {
          if (this.modalData.onClose) {
            this.modalData.onClose(false)
          }
          if (this.userRole.cwsfViewer) {
            localStorage.set('skip_ysc_welcome', '1')
          }
        }
      }
      this.$store.dispatch('hideYscPreRegistrationModal')
    },
    toggleScrolling: function (active) {
      if (this.$route.name !== 'blankPage') {
        active ? this._callback('lockScrolling', false) : this._callback('unlockScrolling', true)
      }
    },
    onChildClick (value) {
      this.userRole = value
    }
  }
}

</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

$modal-body-color: #F2F2F2;
$modal-footer-color: #F7F7F7;
$close-icon-color: #1A051D;
$border-color: #DCDCDC;
$placeholder-font-color: #565656;
$input-background-color: #FFFFFF;
$input-height: 40px;
$bottom-message-font-color: #3F3F3F;

.modal {
  z-index: 50;
}

.modal-card {
  background: $modal-body-color;
  padding: 1.3rem 0 0;
  text-align: center;
  overflow: auto;
@include mobile {
  max-width: 98vw;
}
}

.close {
  top: 0.4rem;
  right: 1rem;
  position: absolute;
  font-size: 1.5rem;
  color:  $close-icon-color;
  border: none;
  padding: 0;
  background: transparent;
&:hover {
   color: $link-hover;
 }
}

.make-login {
  margin: 0.7rem 0 0.4rem;
  text-align: center;
}

.section {
  height: auto;
  padding: 0;

.container {
  margin: auto;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  width: 500px;
@include mobile {
  width: 300px;
  max-width: 300px;
}
@media screen and (max-height: 375px) {
  margin-top: auto;
}
}
}

.title {
  font-family: $primary-font;
  font-weight: $primary-font-weight;
@include mobile{
  font-size: 1.75rem;
}
}

.button {
  border-radius: 0;
  padding: 1rem 1.5rem;
  text-transform: uppercase;
  font-size: 0.9rem;
&.continue-button {
   margin: 1.1rem 0 1.1rem;
   padding: 1.15rem 1.2rem;
 }
&.using-password-button {
   margin: 0 0 1.5rem;
 }
}
.button[disabled] {
  pointer-events: none;
}

.welcome-modal {
  border-bottom: 1px solid $border-color;
  padding-bottom: 1.3rem;
}

.next-button-container {
  margin: 0.5rem 0 0;
  width: 100%;
  background-color: $modal-footer-color;
@include mobile {
  margin: 0;
}
}

.has-account-message {
  color: $bottom-message-font-color;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.welcome-modal.title {
  font-size: 1.5rem;
  margin-bottom: 0;
}

input[placeholder] {
  text-overflow: ellipsis;
  overflow: hidden;
}

.cwsf-parent-container {
  width: 100%;
  display: flex;
  justify-content: center;
::v-deep .checkboxes {
  width: 100% !important;
}
}

</style>
<style lang="scss">
body.ios-modal-fix {
  position: fixed;
}
</style>
